"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Grid_1 = require("@material-ui/core/Grid");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var ConnectedCouponForm_1 = require("./ConnectedCouponForm");
var styles_1 = require("./styles");
var CartSummary = function (props) {
    var classes = props.classes, cart = props.cart;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid_1.default, { item: true, className: classes.cartGridItem },
            React.createElement(Typography_1.default, { variant: "h5" }, "Summary")),
        React.createElement(Grid_1.default, { container: true, className: classes.cartGridItem },
            React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.summaryRow },
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Typography_1.default, { variant: "body2" }, "subtotal")),
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Typography_1.default, { variant: "body2" },
                        "$",
                        cart.subTotal.toFixed(2)))),
            React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.summaryRow },
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Typography_1.default, { variant: "body2" }, "tax")),
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Typography_1.default, { variant: "body2" },
                        "$",
                        cart.taxTotal.toFixed(2)))),
            cart.adjustmentTotal !== 0 && (React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.summaryRow },
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Typography_1.default, { variant: "body2" }, "adjustments")),
                React.createElement(Grid_1.default, { item: true },
                    React.createElement(Typography_1.default, { variant: "body2" },
                        "-$",
                        -cart.adjustmentTotal.toFixed(2))))),
            React.createElement(ConnectedCouponForm_1.default, null),
            React.createElement(Grid_1.default, { container: true, direction: "row", className: classes.summaryRow },
                React.createElement(Typography_1.default, { variant: "h5" }, "total"),
                React.createElement(Typography_1.default, { variant: "h5" },
                    "$",
                    cart.total.toFixed(2))))));
};
exports.default = withStyles_1.default(styles_1.default)(CartSummary);
